/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import { Button, makeStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import arabImage from 'assets/img/arab.png';
import AsyncCustomizeSelect, { OptionType } from 'component/customize_select/async_customize_select';
import { TextErr } from 'component/customize_style_component/styled_title';
import SelectMultipleDropDown, { SelectOption } from 'component/StandardDropDownCheckBox';
import StandardPopup from 'component/StandardPopup';
import { StandardTextFieldStyle } from 'component/StandardTextFieldStyle';
import config from 'config';
import { ToastType } from 'constants/index';
import { cache } from 'graph_ql';
import { GET_TAG_FROM_ALGOLIA } from 'graph_ql/category-tag/tag/queries';
import { CREATE_STYLE, UPDATE_STYLE } from 'graph_ql/createStyle/mutation';
import { GET_IMAGE_DATA, PARSER_URL } from 'graph_ql/createStyle/query';
import { CREATE_ITEM, UPDATE_ITEM } from 'graph_ql/item/mutations';
import { GET_PERSONAS, GET_QUESTIONS_DATA_FROM_ALGOLIA } from 'graph_ql/personas/queries';
import { get, isNull, omit, omitBy, replace, uniq } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import ReactTooltip from 'react-tooltip';
import {
    generateDefaultStyleInformation,
    IBackgroundRemovedMap,
    ICreateStyle,
    setActiveImageIndex,
    setCurrentEditingItemId,
    setEditStyleItemDisabled,
    setRenderRequested as requestRenderCanvas,
    setRenderRequested,
    setStyleItemsAndImageJson,
    updateItem as updateReduxItem,
} from 'redux/create-style/create-style.slice';
import { RootState, useAppSelector } from 'redux/store';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import { TaffiSubjects } from 'types/subjects';
import { getValueSelect, ValidURL } from 'utils/utils';
import parserIcon from '../../../assets/svg/parserIcon.svg';
import UserType from '../../../constants/user';
import { getImageJsonObject } from '../../../utils/canvasHelper';
import IconSelect from './IconSelect';
import { ItemStyleAccess } from './types';
import { GET_BRAND_FROM_ALGOLIA } from 'graph_ql/category-tag/brand/queries';
import { AlgoliaResponse, AlgoliaInput } from 'graph_ql/types/types';
import { IAlgoliaQuestionData } from 'graph_ql/personas/types';
import { IAlgoliaBrandData } from 'graph_ql/category-tag/brand/types';

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

let priceOptionList = [
    { value: 'SAR', label: 'SAR', url: arabImage },
    { value: 'USD', label: 'USD' },
    { value: 'AED', label: 'AED' },
];

export const generateDefaultCreateStyle = () => ({
    url: '',
    title: '',
    description: '',
    price: '',
    currency: priceOptionList[0].value,
    itemCodes: '',
    colorsId: [],
    sizesId: [],
    tagsId: [],
    images: [],
    accessLevel: config.defaultItemStyleAccessLevel,
    creator: '',
    brandId: {},
});

const useStyles = makeStyles(() => ({
    wrapper: {
        width: '100%',
        position: 'relative',
    },
    noBorder: {
        '& input': {
            borderBottom: 'none!important',
        },
        '& input:hover': {
            borderBottom: 'none!important',
        },
        '& input:not(:hover)': {
            borderBottom: 'none!important',
        },
    },
    initialBgWrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: '#1D474F',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .bg': {
            width: '130px',
            height: '130px',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
    },

    imageWrapper: {
        width: '110px',
        height: '110px',
        position: 'relative',
        borderRadius: '16px',
        background: '#B4C8CB',
        padding: '8px',
        display: 'flex!important',
    },
    slickWrapper: {
        '& .slick-slider': {
            height: '109px',
            overflow: 'hidden',
        },
        '& .slick-slide': {
            margin: '0px 4px',
        },
        '& .slick-list': {
            margin: '0px-',
        },
        '& img': {
            width: '100%',
        },
        // "& .slick-cloned": {
        //   display: "none!important",
        // },
    },
    createStyleAddIcon: {
        position: 'absolute',
        top: '70%',
        left: '50%',
        transform: 'translate(-50%,0)',
        fill: '#fff',
    },
    formWrapper: {
        padding: '0px 24px',
        margin: '30px 0px',
    },
    input: {
        color: '#fff',
        border: 'none!important',
        width: '90%',
        textOverflow: 'ellipsis',
        marginTop: '16px',
        '&::placeholder ': {
            fontFamily: 'PoppinsRegular',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#fff',
            opacity: 0.5,
        },
    },
    menuItem: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontStyle: 'normal',
        height: '20px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
    },
    inputWrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '10px',
        '& input': {
            borderBottom: '1px solid #4a6c72!important',
        },
    },
    saveBtn: {
        width: '100%',
        borderRadius: '42px',
        padding: '12px 30px 12px 30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        color: '#1D474F',
        marginTop: '30px',
        '&:hover': {
            background: '#fff',
            color: 'black',
            opacity: '0.5',
        },
        '& >.MuiButton-label': {
            fontFamily: 'Graphik !important',
        },
        '&:disabled': {
            opacity: 0.5,
            color: '#1D474F',
        },
    },
    labelInput: {
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            color: 'blue',
        },
    },
}));
const mapStringToOptionValue = (value: string, options: any[]) => {
    const existedValue = options.find((op) => op.value?.toLowerCase() === value.toLowerCase());
    return existedValue || { value, label: value };
};
interface IFormCreateStyle {
    initialItemValues: ICreateStyle;
    handleClose: (callback?: any) => void;
    currentList: string[];
    styleData?: any;
    setLoadingRemove?: any;
    selectedIndex: any;
    setSelectedIndex: any;
    setEmptyImg: any;
    disabledButton: any;
    setListImage: (payload: string[]) => void;
}

const FormCreateStyle = ({
    initialItemValues,
    handleClose,
    currentList,
    setLoadingRemove,
    selectedIndex,
    setSelectedIndex,
    setEmptyImg,
    disabledButton,
    setListImage,
}: IFormCreateStyle) => {
    const defaultCurrencies = uniq([...['SAR', 'USD', 'AED'], initialItemValues.currency]);
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const dispatch = useDispatch();
    const client = useApolloClient();
    const location = useLocation();
    const history = useHistory();
    const match = useRouteMatch<any>(`${PATH.EDIT_ITEM}/:taffiId`);
    const isItemWithoutStyle = location.pathname === PATH.CREATE_ITEM || match?.params.taffiId;
    const editStyleItemDisabled = useSelector((state: RootState) => state.createStyle.editStyleItemDisabled);
    const {
        currentEditingItemId,
        currentEditingStyleId,
        canvasObject: styleCanvasObject,
        items: styleItems,
        imageJson,
    } = useAppSelector((state: RootState) => state.createStyle);
    const [updateItem] = useMutation(UPDATE_ITEM);
    const [createItem] = useMutation(CREATE_ITEM);
    const [createStyle] = useMutation(CREATE_STYLE);
    const [updateStyle] = useMutation(UPDATE_STYLE);

    const [parseForm, setParseForm] = useState({
        url: '',
        title: '',
        description: '',
        price: '',
        currency: defaultCurrencies,
        itemCodes: '',
        colors: [],
        sizes: [],
        tagsId: [],
        accessLevel: ItemStyleAccess,
        brandId: {},
    });
    const [sizeCurrentPage, setSizeCurrentPage] = useState<number>(0);
    const [sizeSearchTerm, setSizeSearchTerm] = useState<string>('');

    const [colorCurrentPage, setColorCurrentPage] = useState<number>(0);
    const [colorSearchTerm, setColorSearchTerm] = useState<string>('');

    const [tagCurrentPage, setTagCurrentPage] = useState<number>(0);
    const [tagSearchTerm, setTagSearchTerm] = useState<string>('');

    const [brandCurrentPage, setBrandCurrentPage] = useState<number>(0);
    const [brandSearchTerm, setBrandSearchTerm] = useState<string>('');

    const tagSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                userStyles(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters = `enabled: true`;
        return {
            query: '',
            filters,
            hit: 20,
            page: 0,
            facets: [],
        };
    }, []);

    const {
        refetch: refetchTag,
        fetchMore: fetchMoreTag,
        data: tagData,
        loading: tagLoading,
    } = useQuery<AlgoliaResponse<IAlgoliaQuestionData, 'getTagFromAlgolia'>, AlgoliaInput>(GET_TAG_FROM_ALGOLIA, {
        variables: tagSearchVariables,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    });
    const loadTagOptions = async (search: string) => {
        let newOptions;
        const nbPages = tagData?.getTagFromAlgolia?.nbPages || 0;
        if (search !== tagSearchTerm) {
            setTagSearchTerm(search);
            setTagCurrentPage(0);
            newOptions = await refetchTag({
                query: search,
            });
        } else {
            newOptions = await fetchMoreTag({
                variables: {
                    page: tagCurrentPage,
                },
            });
        }
        setTagCurrentPage((prev) => prev + 1);
        const options = newOptions?.data?.getTagFromAlgolia?.hits.map(getValueSelect);
        const hasMore = nbPages > newOptions?.data?.getTagFromAlgolia?.page;
        return {
            options,
            hasMore,
        };
    };

    const colorSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                userStyles(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters = `subject: ${TaffiSubjects.TAFFI_COLOR} AND enabled: true`;
        return {
            query: '',
            filters,
            hit: 20,
            page: 0,
            facets: [],
        };
    }, []);

    const {
        refetch: refetchColor,
        fetchMore: fetchMoreColor,
        data: colorData,
        loading: colorLoading,
    } = useQuery<AlgoliaResponse<IAlgoliaQuestionData, 'getQuestionsDataFromAlgolia'>, AlgoliaInput>(
        GET_QUESTIONS_DATA_FROM_ALGOLIA,
        {
            variables: colorSearchVariables,
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        },
    );
    const loadColorOptions = async (search: string) => {
        let newOptions;
        const nbPages = colorData?.getQuestionsDataFromAlgolia?.nbPages || 0;
        if (search !== colorSearchTerm) {
            setColorSearchTerm(search);
            setColorCurrentPage(0);
            newOptions = await refetchColor({
                query: search,
            });
        } else {
            newOptions = await fetchMoreColor({
                variables: {
                    page: colorCurrentPage,
                },
            });
        }
        setColorCurrentPage((prev) => prev + 1);
        const options = newOptions?.data?.getQuestionsDataFromAlgolia?.hits.map(getValueSelect);
        const hasMore = nbPages > newOptions?.data?.getQuestionsDataFromAlgolia?.page;
        return {
            options,
            hasMore,
        };
    };

    const sizeSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                userStyles(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters = `subject: ${TaffiSubjects.TAFFI_SIZE} AND enabled: true`;

        return {
            query: '',
            filters,
            hit: 20,
            page: 0,
            facets: [],
        };
    }, []);

    const {
        refetch: refetchSize,
        fetchMore: fetchMoreSize,
        data: sizeData,
        loading: sizeLoading,
    } = useQuery<AlgoliaResponse<IAlgoliaQuestionData, 'getQuestionsDataFromAlgolia'>, AlgoliaInput>(
        GET_QUESTIONS_DATA_FROM_ALGOLIA,
        {
            variables: sizeSearchVariables,
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        },
    );
    const loadSizeOptions = async (search: string) => {
        let newOptions;
        const nbPages = sizeData?.getQuestionsDataFromAlgolia?.nbPages || 0;
        if (search !== sizeSearchTerm) {
            setSizeSearchTerm(search);
            setSizeCurrentPage(0);
            newOptions = await refetchSize({
                query: search,
            });
        } else {
            newOptions = await fetchMoreSize({
                variables: {
                    page: sizeCurrentPage,
                },
            });
        }
        setSizeCurrentPage((prev) => prev + 1);
        const options = newOptions?.data?.getQuestionsDataFromAlgolia?.hits.map(getValueSelect);
        const hasMore = nbPages > newOptions?.data?.getQuestionsDataFromAlgolia?.page;
        return {
            options,
            hasMore,
        };
    };
    const { data: itemStyleAccessData } = useQuery(GET_PERSONAS, {
        variables: {
            field: 'title',
            value: '',
            subject: TaffiSubjects.ITEM_STYLE_ACCESS,
            paging: { page: 0, size: 0 },
        },
        fetchPolicy: 'network-only',
    });

    const brandSearchVariables = useMemo(() => {
        let filters = `enabled: true`;
        return {
            query: '',
            filters,
            hit: 20,
            page: 0,
            facets: [],
        };
    }, []);
    const {
        refetch: refetchBrand,
        fetchMore: fetchMoreBrand,
        data: brandData,
        loading: brandLoading,
    } = useQuery<AlgoliaResponse<IAlgoliaBrandData, 'getBrandFromAlgolia'>, AlgoliaInput>(GET_BRAND_FROM_ALGOLIA, {
        variables: brandSearchVariables,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    });
    const loadBrandOptions = async (search: string) => {
        let newOptions;
        const nbPages = brandData?.getBrandFromAlgolia?.nbPages || 0;
        if (search !== brandSearchTerm) {
            setBrandSearchTerm(search);
            setBrandCurrentPage(0);
            newOptions = await refetchBrand({
                query: search,
            });
        } else {
            newOptions = await fetchMoreBrand({
                variables: {
                    page: brandCurrentPage,
                },
            });
        }
        setBrandCurrentPage((prev) => prev + 1);
        const options = newOptions?.data?.getBrandFromAlgolia?.hits.map(getValueSelect);
        const hasMore = nbPages > newOptions?.data?.getBrandFromAlgolia?.page;
        return {
            options,
            hasMore,
        };
    };

    const defaultCreateStyle = useMemo(
        () => ({
            ...initialItemValues,
            colorsId: get(initialItemValues, ['colors'], []).map(getValueSelect),
            sizesId: get(initialItemValues, ['sizes'], []).map(getValueSelect),
            tagsId: get(initialItemValues, ['tags'], []).map(getValueSelect),
            accessLevel: get(initialItemValues, ['accessLevel'], []),
            brandId: getValueSelect(get(initialItemValues, ['brand'], [])),
        }),
        [initialItemValues],
    );
    const {
        control,
        handleSubmit,
        reset,
        getValues,
        setValue,
        watch,
        formState: { errors },
        setError,
    } = useForm({
        defaultValues: defaultCreateStyle,
    });
    const colorOptions = useMemo(
        () =>
            currentEditingItemId
                ? [
                    ...get(colorData, ['getQuestionsDataFromAlgolia', 'hits'], []).map(getValueSelect),
                    ...(watch('colorsId') || []),
                ]
                : (colorData?.getQuestionsDataFromAlgolia?.hits || []).map(getValueSelect),
        [colorData?.getQuestionsDataFromAlgolia?.hits, currentEditingItemId],
    );
    const sizeOptions = useMemo(
        () =>
            currentEditingItemId
                ? [
                    ...get(sizeData, ['getQuestionsDataFromAlgolia', 'hits'], []).map(getValueSelect),
                    ...(watch('sizesId') || []),
                ]
                : get(sizeData, ['getQuestionsDataFromAlgolia', 'hits'], []).map(getValueSelect),
        [sizeData?.getQuestionsDataFromAlgolia?.hits],
    );

    const enableParserUrl = true;
    const classes = useStyles();
    const [loading, setLoading] = useState<boolean>(false);
    const [hasFill, setHasFill] = useState<boolean>(false);
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        path: '',
        type: '',
        closeButton: true,
        onFirstButtonClick: () => {},
    });
    useEffect(() => {
        return function clean() {
            dispatch(setCurrentEditingItemId(null));
        };
    }, []);

    useEffect(() => {
        reset(defaultCreateStyle);
    }, [defaultCreateStyle]);

    const watchShopUrl = watch('url');
    useEffect(() => {
        setHasFill(false);
    }, [watchShopUrl]);

    async function runQuery(url: string) {
        try {
            setLoading(true);
            const {
                data: { parseUrl },
            } = await client.query({
                query: PARSER_URL,
                variables: { url },
                fetchPolicy: 'network-only',
            });
            if (parseUrl) {
                let merger = omitBy({ ...parseForm, ...parseUrl }, isNull) as any;
                const currency = parseUrl.currency;
                merger = { ...merger, currency };
                if (merger.images) {
                    setListImage(merger.images);
                }
                if (!merger.images?.length || !merger.price) {
                    setModalShow({
                        show: true,
                        title: 'Something went wrong. ',
                        content:
                            'Failed to obtain some of the item details automatically. Please enter the missing item details manually.',
                        button1: 'Okay',
                        button2: '',
                        path: '',
                        type: ToastType.Warning,
                        closeButton: true,
                        onFirstButtonClick: () => {},
                    });
                }
                setParseForm(merger);
                setValue('title', merger.title);
                setValue('description', merger.description);
                setValue(
                    'colorsId',
                    get(merger, ['colors'], []).map((color) => mapStringToOptionValue(color, colorOptions)),
                );
                setValue(
                    'sizesId',
                    get(merger, ['sizes'], []).map((size) => mapStringToOptionValue(size, sizeOptions)),
                );
                if (defaultCurrencies.includes(merger.currency)) {
                    setValue('price', merger.price);
                    setValue('currency', merger.currency);
                } else {
                    setValue('price', '');
                    setValue('currency', defaultCurrencies[0]);
                }
                setLoading(false);
                setHasFill(true);
            }
        } catch (e: any) {
            console.log('error', e);
            setLoading(false);
            setHasFill(true);
            setModalShow({
                show: true,
                title: 'Something went wrong. ',
                content:
                    'Failed to obtain some of the item details automatically. Please enter the missing item details manually.',
                button1: 'Okay',
                button2: '',
                path: '',
                type: ToastType.Error,
                closeButton: true,
                onFirstButtonClick: () => {},
            });
        }
    }

    const processShopUrl = async () => {
        setError('currency', {});
        const url = getValues('url');
        await runQuery(url);
    };

    const showError = (message) => {
        setModalShow({
            show: true,
            title: 'Something went wrong.',
            content: message,
            button1: 'Okay',
            button2: '',
            path: '',
            type: ToastType.Error,
            closeButton: true,
            onFirstButtonClick: () => {},
        });
    };

    const transformItemData = (value) => {
        const { price } = value;
        const priceValue = price ? replace(price, /,/g, '') : 0;

        return omit(
            {
                ...value,
                price: +priceValue,
            },
            ['colors', 'sizes', 'tags', 'categories', 'collection', 'labels', '__typename', 'creator', 'user', 'brand'],
        );
    };

    const submitItemForSaving = async (image, value) => {
        if (image && ValidURL(image.trim()) && value) {
            let removedBgImage = '';
            let existed: any = null;

            if (!isItemWithoutStyle) {
                if (currentEditingItemId) {
                    // check if user select another image or use the old image
                    // ignore remove background if the same image was selected
                    existed = imageJson.find((i: any) => i.url === image);
                    if (existed) {
                        removedBgImage = existed.imageCanvas;
                    } else {
                        //check if the image is existed in the backgroundRemovedMap
                        const existed = get(value, 'backgroundRemovedMap', []).find(
                            (i: IBackgroundRemovedMap) => i.originalUrl === image,
                        );
                        if (existed) {
                            removedBgImage = existed.backgroundRemovedUrl;
                        }
                    }
                }

                if (!existed) {
                    const {
                        data: { getImageData },
                    } = await client.query({
                        query: GET_IMAGE_DATA,
                        variables: {
                            input: {
                                url: image,
                                removeBackground: true,
                                itemId: value.id,
                            },
                        },
                        fetchPolicy: 'network-only',
                    });
                    removedBgImage = getImageData ? getImageData.imageUrl : null;
                }
            }

            if (removedBgImage !== '' || isItemWithoutStyle) {
                if (currentEditingItemId || match?.params.taffiId) {
                    // update item only
                    try {
                        let res: any = null;
                        if (!editStyleItemDisabled) {
                            res = await updateItem({
                                variables: {
                                    input: {
                                        ...transformItemData(value),
                                        images: currentList.reduce((urls, img) => {
                                            if (img !== '') {
                                                // @ts-ignore
                                                urls.push(img);
                                            }
                                            return urls;
                                        }, []),
                                    },
                                },
                            });
                        }

                        if (!isItemWithoutStyle) {
                            if (!editStyleItemDisabled && res) {
                                const newItemData = res.data.updateItem;
                                dispatch(updateReduxItem(newItemData));
                            }
                            const imagesOnCanvas: any[] = [];
                            let shouldReRenderCanvas = false;
                            for (const img of imageJson) {
                                if (img.itemId === value.id && !existed) {
                                    const newImage = await getImageJsonObject(
                                        image,
                                        removedBgImage,
                                        styleCanvasObject,
                                        value.id,
                                    );
                                    imagesOnCanvas.push(newImage);
                                    shouldReRenderCanvas = true;
                                } else {
                                    imagesOnCanvas.push(img);
                                }
                            }
                            const style = await updateStyle({
                                variables: {
                                    input: {
                                        id: currentEditingStyleId,
                                        imageJson: imagesOnCanvas,
                                    },
                                },
                            });
                            dispatch(
                                setStyleItemsAndImageJson({
                                    items: style.data.updateStyle.items,
                                    imageJson: style.data.updateStyle.imageJson,
                                }),
                            );
                            dispatch(setRenderRequested(shouldReRenderCanvas));
                        }

                        setLoadingRemove(false);
                        handleClose();
                    } catch (e) {
                        console.error(e);
                        setLoadingRemove(false);
                        showError('An error occurred while updating the item. Please try again.');
                    }
                } else {
                    try {
                        const item = await createItem({
                            variables: {
                                input: {
                                    ...transformItemData(value),
                                    images: currentList.reduce((urls, img) => {
                                        if (img !== '') {
                                            // @ts-ignore
                                            urls.push(img);
                                        }
                                        return urls;
                                    }, []),
                                },
                            },
                        });

                        if (isItemWithoutStyle) {
                            if (location.pathname === PATH.CREATE_ITEM) {
                                const modalContent =
                                    userDetail.userType === UserType.Stylist
                                        ? `Item ${value.title} has been added and is now available to be used for style creation.`
                                        : `Item ${value.title} is being processed. Once the processing is complete, it will be added to your wardrobe.`;
                                setModalShow({
                                    show: true,
                                    title: 'Item successfully added.',
                                    content: modalContent,
                                    button1: 'Add another item',
                                    button2: 'I’m done',
                                    onFirstButtonClick: () => {
                                        setListImage(['', '', '', '']);
                                        reset(defaultCreateStyle);
                                        setLoadingRemove(false);
                                    },
                                    type: ToastType.Success,
                                    closeButton: false,
                                    path: userDetail.userType === UserType.Stylist ? PATH.MY_ITEMS : PATH.WARDROBE,
                                });
                            } else {
                                setLoadingRemove(false);
                                handleClose();
                                history.push(`${PATH.ITEM_DETAIL}/${item?.data?.createItem?.taffiId}`);
                            }
                        } else {
                            const itemId = item.data.createItem.id;
                            if (currentEditingStyleId) {
                                let items: any[] = styleItems.map((item) => {
                                    return {
                                        itemId: item.id,
                                        variant: omit(item.variant, '__typename'),
                                    };
                                });
                                items.push({
                                    itemId,
                                    variant: {
                                        color: '',
                                        size: '0',
                                    },
                                });
                                const imagesOnCanvas: any[] = [...imageJson];
                                const newImageOnCanvas = await getImageJsonObject(
                                    image,
                                    removedBgImage,
                                    styleCanvasObject,
                                    itemId,
                                );
                                imagesOnCanvas.push(newImageOnCanvas);
                                const itemIdsOnCanvas = imagesOnCanvas
                                    .filter((image) => image.itemId)
                                    .map((image) => image.itemId);
                                const itemIdOnItems = items.filter((item) => !!item?.itemId).map((item) => item.itemId);
                                items = items.filter((item) => itemIdsOnCanvas.includes(item.itemId));
                                const input: any = {
                                    id: currentEditingStyleId,
                                    items,
                                    imageJson: imagesOnCanvas.filter(
                                        (image) => !image.itemId || itemIdOnItems.includes(image.itemId),
                                    ),
                                };
                                if (items.length === 1) {
                                    input.images = [removedBgImage];
                                }
                                const style = await updateStyle({
                                    variables: {
                                        input,
                                    },
                                });
                                dispatch(
                                    setStyleItemsAndImageJson({
                                        items: style.data.updateStyle.items,
                                        imageJson: style.data.updateStyle.imageJson,
                                    }),
                                );
                                dispatch(setRenderRequested(true));
                                setLoadingRemove(false);
                                handleClose();
                            } else {
                                const style = await createStyle({
                                    variables: {
                                        input: {
                                            ...generateDefaultStyleInformation(),
                                            images: [removedBgImage],
                                            items: [
                                                {
                                                    itemId,
                                                    variant: {
                                                        color: '',
                                                        size: '0',
                                                    },
                                                },
                                            ],
                                            imageJson: [
                                                await getImageJsonObject(
                                                    image,
                                                    removedBgImage,
                                                    styleCanvasObject,
                                                    itemId,
                                                ),
                                            ],
                                        },
                                    },
                                });
                                setLoadingRemove(false);
                                handleClose();
                                history.replace(PATH.EDIT_STYLE_CANVAS + '/' + style.data.createStyle.taffiId);
                            }
                        }
                    } catch (e) {
                        console.error(e);
                        setLoadingRemove(false);
                        showError(
                            `An error occurred while creating the item${
                                isItemWithoutStyle ? '' : ' or the style'
                            }. Please try again.`,
                        );
                    }
                }
            } else {
                setLoadingRemove(false);
                showError(
                    'An error occurred while processing the selected item image. Please try again or select a different item image.',
                );
            }
        } else {
            setLoadingRemove(false);
            showError(
                'An error occurred while processing the selected item image. Please try again or select a different item image.',
            );
        }
    };

    return (
        <form
            className={classes.formWrapper}
            onSubmit={handleSubmit(async (value) => {
                try {
                    if (currentList.filter((image) => image !== '').length === 0) {
                        setEmptyImg(true);
                        window.scrollTo(0, 0);
                        return;
                    } else {
                        setEmptyImg(false);
                    }
                    if (value.url && !ValidURL(value.url)) return;

                    if (value.sizesId && value.sizesId.length) {
                        value.sizesId = value.sizesId.map((size) => ({
                            ...(size.id ? { id: size.id } : {}),
                            value: size.value,
                            title: size.value,
                        })) as any;
                    }
                    if (value.colorsId && value.colorsId.length > 0) {
                        value.colorsId = value.colorsId.map((color) => ({
                            ...(color.id ? { id: color.id } : {}),
                            value: color.value,
                            title: color.value,
                        })) as any;
                    }
                    if (value.tagsId && value.tagsId.length > 0) {
                        value.tagsId = value.tagsId.map((tag: any) => ({
                            ...(tag.id ? { id: tag.id } : {}),
                            name: tag.value,
                        })) as any;
                    }
                    if (userDetail.userType === UserType.Customer) {
                        value.accessLevel = ItemStyleAccess.Public;
                    }
                    if (value.brandId) {
                        value.brandId = {
                            id: value?.brandId?.id ? value?.brandId?.id : null,
                            name: value?.brandId?.value,
                        } as any;
                    }
                    setLoadingRemove(true);
                    let imageToRemoveBackground: string;
                    // check if user is selecting placeholder image as item image
                    if (currentList[selectedIndex] === '') {
                        setSelectedIndex(0);
                        imageToRemoveBackground = currentList[0];
                    } else {
                        imageToRemoveBackground = currentList[selectedIndex];
                    }
                    await submitItemForSaving(imageToRemoveBackground, value);
                    if (!isItemWithoutStyle) {
                        dispatch(requestRenderCanvas(true));
                        dispatch(setActiveImageIndex(styleItems.length));
                    }
                    dispatch(setEditStyleItemDisabled(false));
                } catch (e) {
                    console.error(e);
                    setModalShow({
                        show: true,
                        title: 'Something went wrong.',
                        content: `There is an issue creating ${
                            isItemWithoutStyle ? 'item' : 'style'
                        }. Please try again.`,
                        button1: 'Okay',
                        button2: '',
                        path: '',
                        type: ToastType.Error,
                        closeButton: true,
                        onFirstButtonClick: () => {},
                    });
                }
            })}
        >
            <div className={classes.inputWrapper}>
                <Controller
                    name="url"
                    control={control}
                    rules={{
                        required: { value: userDetail.userType === UserType.Stylist, message: 'Shop URL is required.' },
                    }}
                    render={({ field, fieldState }) => (
                        <>
                            <StandardTextFieldStyle
                                error={!!fieldState.error}
                                label="Shop URL"
                                {...field}
                                disabled={editStyleItemDisabled}
                                onBlur={(e) => {
                                    setValue('url', e.target.value.trim());
                                }}
                                // onChange={()=> }
                                style={{
                                    paddingRight: `${
                                        getValues('url') &&
                                        ValidURL(getValues('url').trim()) &&
                                        !hasFill &&
                                        enableParserUrl
                                            ? '42px'
                                            : '0px'
                                    }`,
                                }}
                                InputLabelProps={{
                                    style: {
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        width: '100%',
                                        color: !!fieldState.error ? 'red' : themes.palette.primary.main,
                                    },
                                }}
                            />

                            {!currentEditingItemId &&
                                ValidURL(getValues('url')) &&
                                ValidURL(getValues('url').trim() || initialItemValues.url || '') &&
                                enableParserUrl &&
                                !hasFill && (
                                <span
                                    onClick={processShopUrl}
                                    style={{
                                        marginTop: 'auto',
                                        marginBottom: 'auto',
                                        backgroundColor: `transparent`,
                                        float: 'right',
                                        paddingRight: 0,
                                        position: 'absolute',
                                        right: '-11px',
                                        bottom: '7px',
                                        border: 0,
                                        pointerEvents: `${!loading ? 'auto' : 'none'}`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '50%',
                                        marginRight: '12px',
                                    }}
                                    data-tip="Click to automatically populate item details from Shop URL."
                                >
                                    {loading ? (
                                        <ClipLoader
                                            color={themes.palette.primary.main}
                                            loading={loading}
                                            size={18}
                                        />
                                    ) : (
                                        <img src={parserIcon} alt="" />
                                    )}
                                </span>
                            )}
                            <ReactTooltip globalEventOff={isMobile ? 'touchstart' : undefined} />
                        </>
                    )}
                />
                {getValues('url') && !ValidURL(getValues('url')) && <TextErr>Shop URL is invalid.</TextErr>}
            </div>
            <div
                style={{
                    marginTop: '10px',
                }}
            >
                <Controller
                    name="brandId"
                    control={control}
                    render={({ field, fieldState }) => (
                        <AsyncCustomizeSelect
                            handleSelectItem={(list) => {
                                field.onChange(list);
                            }}
                            error={!!fieldState.error}
                            field="brand"
                            placeholder="Brand Name"
                            onChangeInput={() => null}
                            defaultValue={watch('brandId')?.value ? [watch('brandId') as OptionType] : []}
                            isDisabled={editStyleItemDisabled}
                            isLoading={brandLoading}
                            loadOptions={loadBrandOptions}
                            isMulti={false}
                        />
                    )}
                />
            </div>
            <div className={classes.inputWrapper}>
                <Controller
                    name="title"
                    control={control}
                    rules={{
                        required: { value: true, message: 'Item Name is require.' },
                    }}
                    render={({ field, fieldState }) => (
                        <StandardTextFieldStyle
                            {...field}
                            label="Item Name"
                            error={!!fieldState.error}
                            disabled={editStyleItemDisabled}
                            InputLabelProps={{
                                style: {
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    width: '100%',
                                    color:
                                        !!fieldState.error && !getValues('title') ? 'red' : themes.palette.primary.main,
                                },
                            }}
                        />
                    )}
                />
            </div>
            <div
                style={{
                    marginTop: '10px',
                }}
            >
                <Controller
                    name="description"
                    control={control}
                    rules={{
                        required: {
                            value: userDetail.userType === UserType.Stylist && !editStyleItemDisabled,
                            message: 'Description is require.',
                        },
                    }}
                    render={({ field, fieldState }) => (
                        <StandardTextFieldStyle
                            {...field}
                            error={!!fieldState.error}
                            label="Description"
                            multiline
                            fullWidth
                            disabled={editStyleItemDisabled}
                            InputLabelProps={{
                                style: {
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    width: '100%',
                                    color:
                                        !!fieldState.error && !getValues('description')
                                            ? 'red'
                                            : themes.palette.primary.main,
                                },
                            }}
                        />
                    )}
                />
            </div>

            <Controller
                name="colorsId"
                control={control}
                render={({ field, fieldState }) => (
                    <AsyncCustomizeSelect
                        field={'colors'}
                        isLoading={colorLoading}
                        loadOptions={loadColorOptions}
                        error={!!fieldState.error}
                        placeholder="Color"
                        isDisabled={editStyleItemDisabled}
                        defaultValue={watch('colorsId')}
                        handleSelectItem={(list) => {
                            field.onChange(list);
                        }}
                        onChangeInput={() => null}
                    />
                )}
            />

            <Controller
                name="sizesId"
                control={control}
                render={({ field, fieldState }) => (
                    <AsyncCustomizeSelect
                        field={'sizes'}
                        isLoading={sizeLoading}
                        loadOptions={loadSizeOptions}
                        error={!!fieldState.error}
                        placeholder="Sizes"
                        isDisabled={editStyleItemDisabled}
                        defaultValue={watch('sizesId')}
                        handleSelectItem={(list) => {
                            field.onChange(list);
                        }}
                        onChangeInput={() => null}
                    />
                )}
            />

            <div className={classes.inputWrapper}>
                <Controller
                    name="price"
                    control={control}
                    rules={{
                        required: { value: userDetail.userType === UserType.Stylist, message: 'Price is require.' },
                    }}
                    render={({ field, fieldState }) => (
                        <NumericFormat
                            customInput={StandardTextFieldStyle}
                            {...field}
                            label="Price"
                            error={!!fieldState.error}
                            disabled={editStyleItemDisabled}
                            thousandSeparator=","
                            decimalScale={2} // DEFAULT_FLOAT_PRECISION
                            allowLeadingZeros={false}
                            allowNegative={false}
                            InputLabelProps={{
                                style: {
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    width: '100%',
                                    color:
                                        !!fieldState.error && !getValues('price') ? 'red' : themes.palette.primary.main,
                                },
                            }}
                        />
                    )}
                />

                <div style={{ position: 'absolute', right: 0, top: '14px' }}>
                    <Controller
                        name="currency"
                        control={control}
                        render={({ field, fieldState }) => {
                            return (
                                <IconSelect
                                    selectedValue={field.value}
                                    onChange={field.onChange}
                                    error={!!fieldState.error?.message}
                                >
                                    {defaultCurrencies.map((currencyOption, index) => (
                                        <MenuItem
                                            key={index}
                                            value={currencyOption}
                                            className={classes.menuItem}
                                            disabled={editStyleItemDisabled}
                                        >
                                            {currencyOption}
                                        </MenuItem>
                                    ))}
                                </IconSelect>
                            );
                        }}
                    />
                </div>
            </div>
            {userDetail.userType === UserType.Stylist && (
                <div className={classes.inputWrapper}>
                    <Controller
                        name="itemCodes"
                        control={control}
                        // rules={{
                        //     required: {value: true, message: "Code is require."},
                        // }}
                        render={({ field, fieldState }) => (
                            <StandardTextFieldStyle
                                {...field}
                                label="Code"
                                error={!!fieldState.error}
                                disabled={editStyleItemDisabled}
                                InputLabelProps={{
                                    style: {
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        width: '100%',
                                        color: !!fieldState.error ? 'red' : themes.palette.primary.main,
                                    },
                                }}
                            />
                        )}
                    />
                </div>
            )}
            <Controller
                name="tagsId"
                control={control}
                rules={{
                    required: {
                        value: !editStyleItemDisabled && userDetail.userType === UserType.Stylist,
                        message: 'Tags is require.',
                    },
                }}
                render={({ field, fieldState }) => (
                    <AsyncCustomizeSelect
                        field={'tags'}
                        isLoading={tagLoading}
                        loadOptions={loadTagOptions}
                        error={!!fieldState.error}
                        placeholder="Tags"
                        isDisabled={editStyleItemDisabled}
                        defaultValue={watch('tagsId')}
                        handleSelectItem={(list) => {
                            field.onChange(list);
                        }}
                        onChangeInput={() => null}
                    />
                )}
            />
            {userDetail.userType === UserType.Stylist && (
                <Controller
                    name="accessLevel"
                    control={control}
                    rules={{
                        required: { value: true, message: 'Access Level is required.' },
                    }}
                    render={({ field, fieldState }) => (
                        <SelectMultipleDropDown
                            placeholder={'Access Level'}
                            listSelectedValue={field.value || ''}
                            onChange={(newValue) => field.onChange(newValue[0])}
                            error={!!fieldState.error}
                            anchorId="accessLevel-select"
                            isSingle={true}
                            isBadgeDropdown
                            disable={editStyleItemDisabled}
                        >
                            {itemStyleAccessData &&
                            itemStyleAccessData?.getQuestionData &&
                            itemStyleAccessData?.getQuestionData?.data?.length > 0 ? (
                                    itemStyleAccessData?.getQuestionData?.data.map((accessLevel, index) => (
                                        <SelectOption
                                            value={accessLevel.value}
                                            label={accessLevel.title}
                                            key={`accessLevel_${index}`}
                                            descriptions={accessLevel?.descriptions}
                                        />
                                    ))
                                ) : (
                                    <></>
                                )}
                        </SelectMultipleDropDown>
                    )}
                />
            )}
            {Object.keys(errors).length === 0 ||
            (getValues('url') &&
                getValues('title') &&
                getValues('price') &&
                getValues('description') &&
                getValues('colorsId') &&
                getValues('sizesId') &&
                getValues('itemCodes') &&
                getValues('tagsId').length > 0 &&
                getValues('accessLevel') &&
                getValues('creator') &&
                getValues('brandId'))
                ? null
                : !errors?.currency && <TextErr>Please enter the highlighted fields.</TextErr>}
            <div>
                {Object.keys(errors).length > 0 && !!errors?.currency?.message && (
                    <TextErr>Specify the item price in SAR currency.</TextErr>
                )}
            </div>
            <Button className={classes.saveBtn} type="submit">
                {location.pathname === PATH.CREATE_ITEM ? 'Add item' : 'Save'}
            </Button>
            {modalShow.show && (
                <StandardPopup
                    show={modalShow.show}
                    onHide={() => {
                        setModalShow({ ...modalShow, show: false });
                    }}
                    title={modalShow.title}
                    content={modalShow.content}
                    button1={modalShow.button1}
                    button2={modalShow.button2}
                    type={modalShow.type as any}
                    closeButton={modalShow.closeButton}
                    onSecondButtonClick={() => {
                        if (modalShow.path) history.push(modalShow.path);
                    }}
                    onFirstButtonClick={modalShow.onFirstButtonClick}
                />
            )}
        </form>
    );
};

export default FormCreateStyle;
